import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { shiftsService } from '../services/api';

interface HeaderProps {
  user?: { name: string; role?: string; full_name?: string; email?: string; withdrawn?: boolean } | null;
  onLogout?: () => void;
  hasBookings?: boolean;
  sickNoteEnabled?: boolean;
  isLoadingBookings?: boolean;
}

export function Header({ user, onLogout, hasBookings, sickNoteEnabled, isLoadingBookings }: HeaderProps) {
  const [eventName, setEventName] = useState<string>('Roskilde Festival');

  useEffect(() => {
    shiftsService.getSettings().then((response) => {
      console.log('Header: Fetched settings response:', response);
      const name = response?.data?.event_name;
      console.log('Header: Extracted event_name:', name);
      if (name && typeof name === 'string') {
        console.log('Header: Setting eventName to:', name);
        setEventName(name);
      }
    }).catch((err) => {
      console.error('Header: Failed to fetch settings:', err);
      // Use default if settings fetch fails
    });
  }, []);

  return (
    <header className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">
            <Link to="/" className="hover:text-gray-700">
              🎪 Volunteer Manager
            </Link>
          </h1>
          <p className="text-sm text-gray-600">{eventName}</p>
        </div>
        <div className="flex items-center gap-4">
          {user?.role === 'volunteer' && !user?.withdrawn && (
            <>
              <Link
                to="/"
                className="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600"
              >
                Dashboard
              </Link>
            </>
          )}
          {user?.role === 'admin' && !user?.withdrawn && (
            <Link
              to="/admin?tab=overview"
              onClick={() => localStorage.setItem('adminMode', 'dashboard')}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Admin
            </Link>
          )}
          {(user?.role === 'supervisor' || user?.role === 'admin') && !user?.withdrawn && (
            <Link
              to="/supervisor"
              className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
            >
              Supervisor
            </Link>
          )}
          {user && sickNoteEnabled && !user?.withdrawn && (
            <Link
              to="/sick-note"
              className="px-4 py-2 bg-amber-500 text-white rounded hover:bg-amber-600"
            >
              Sick Note
            </Link>
          )}
          {user && (
            <div className="text-right">
              <div className="text-gray-700">{user.full_name || user.name || user.email}</div>
              {onLogout && (
                <button
                  onClick={onLogout}
                  className="text-red-600 hover:text-red-700 underline text-sm mt-1"
                >
                  Log out
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
